import React, { useCallback } from 'react';

import { useRouter } from 'expo-router';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { useUnreadNewsFeedCount } from 'state/braze/hooks/use-unread-news-feed-count';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import {
  BadgeText,
  StyledBellIcon,
  StyledNotificationButton,
  UnreadNotificationBadge,
} from './styled';

const MAX_NOTIFICATIONS_IN_BADGE = 9;
const NOTIFICATION_INBOX_BUTTON_NAME = 'Notification Inbox';

export const NotificationsButton = () => {
  const router = useRouter();

  const { count: unreadContentCards, isReady: isUnreadCountReady } = useUnreadNewsFeedCount();
  const badgeUnreadCount = isUnreadCountReady && unreadContentCards > 0 ? unreadContentCards : 0;

  const onOpenPanel = useCallback(() => {
    logButtonClick({
      attributes: {
        component: ClickEventComponentNames.BUTTON,
        name: NOTIFICATION_INBOX_BUTTON_NAME,
        Name: NOTIFICATION_INBOX_BUTTON_NAME,
        unreadCount: badgeUnreadCount,
      },
    });
    router.navigate(routes.notificationInbox);
  }, [badgeUnreadCount, router]);

  return (
    <>
      <StyledNotificationButton
        variant={ActionButtonVariants.TEXT_ONLY}
        size={ActionButtonSizes.SMALL}
        testID="app-header-notification-cta"
        onPress={onOpenPanel}
        skipLogEvent
        startIcon={<StyledBellIcon />}
        accessibilityLabel={t('news')}
      >
        {badgeUnreadCount > 0 && (
          <UnreadNotificationBadge>
            <BadgeText>
              {badgeUnreadCount > MAX_NOTIFICATIONS_IN_BADGE
                ? `${MAX_NOTIFICATIONS_IN_BADGE}+`
                : badgeUnreadCount}
            </BadgeText>
          </UnreadNotificationBadge>
        )}
      </StyledNotificationButton>
    </>
  );
};
